export default angular.module("mars.vet.dnareports.controllers.percentage", []).controller('PercentagesController',
    function($rootScope, $scope, $window,
        EntryService, EntryIDService, BreedListService, NavigationService, TranslationService, UtilityService,
        reportdata) {
        'ngInject';

        let resultString = reportdata.resultString;
        let sampleDetails = reportdata.sampleDetails;

        var reportType = 'online';
        $scope.onloadFun = function() {
            reportType = 'pdf';
        }
        EntryService.getEntry(EntryIDService.getEntryID('Ancestry')).then(function(response) {
            var fields = response.fields;
            if (reportType != 'pdf') {
                $rootScope.pageTitle = fields.title;
            }
            $scope.subtitle = fields.subtitle;
            $scope.breedtestsEntryID = EntryIDService.getEntryID('Breed Tests');
            $scope.translation = TranslationService.getTranslation;
            $scope.title = fields.title;
            //
            // generate pie chart
            //
            $scope.sortedBreedList = BreedListService.getSortedBreedList();
            var data = new google.visualization.DataTable();
            data.addColumn('string', 'Breed');
            data.addColumn('number', 'Percentages');

            var mbPosition = 0;

            //
            // Standard colors for the pie chart
            // Standard colors for the mixed Breed
            // 50% colors for the standard colors for legend highlight
            //
            var colors = ['#0057b8', '#97d701', '#ff8200', '#59cbE8', '#7fabdb', '#ffc07f', '#cbeb80', '#ace5f3'];
            var highlightColors = ['#7fabdb', '#cbeb80', '#ffc07f', '#ace5f3', '#ace5f3', '#ffc07f', '#cbeb80', '#ace5f3'];
            var mixedBreedColors = ['#4d4d4f'];

            angular.forEach(BreedListService.getSortedBreedList(), function(value, key) {
                mbPosition++;
                var tempArray = [value['breed'], value['count']];
                if (value['breed'].trim() == 'Mixed Breed Groups') {
                    $scope.mixedBreedGroups = true;
                    $scope.next5 = resultString.next5;
                    colors.splice(mbPosition - 1, 0, "#4d4d4f");
                    highlightColors.splice(mbPosition - 1, 0, "#979797");
                }
                data.addRow(tempArray);
            });

            $scope.colors = colors;
            $scope.highlightColors = highlightColors;
            $scope.mixedBreedColors = mixedBreedColors;

            NavigationService.setNavigationUrls();

            var pieFontSize = 15;
            var w = window.innerWidth;
            var h = window.innerHeight;
            if (w < 500) {
                pieFontSize = 12;
            }

            var options = {
                legend: 'none',
                fontSize: pieFontSize,
                titleTextStyle: {
                    color: '#FFFFFF'
                },
                'tooltip': {
                    trigger: 'none'
                },
                pieSliceTextStyle: {
                    color: 'white',
                },
                enableInteractivity: false,
                chartArea: {
                    left: "3%",
                    top: "3%",
                    height: "80%",
                    width: "70%"
                },
                colors: colors
            };
//            var d = resultString.event[0]['eventDate'].substring(0, 10);
            //$scope.processDate=new Date(d).toDateString();;
//            $scope.processDate = UtilityService.formatDate(resultString.event[0]['eventDate']);
            var percentagechart = new google.visualization.PieChart(document.getElementById('piechart'));
            percentagechart.draw(data, options);
            //
            // generate remainder of page
            //


            var printChartoptions = {
                width: 600,
                height: 600,
                legend: 'right',
                fontSize: '8px',
                titleTextStyle: {
                    color: '#FFFFFF'
                },
                legend: {
                    maxLines: 2,
                    textStyle: {
                        fontSize: 15
                    }
                },
                'tooltip': {
                    trigger: 'none'
                },
                pieSliceText: 'percentage',
                pieSliceTextStyle: {
                    color: 'white',
                    fontSize: 15
                },
                enableInteractivity: false,
                chartArea: {
                    left: 0,
                    'width': '80%',
                    'height': '80%'
                },
                colors: colors
            };


            if (reportType == 'pdf') {
//                var d = resultString.event[0]['eventDate'].substring(0, 10);
//                $scope.processDate = UtilityService.formatDate(resultString.event[0]['eventDate']);
                var chart_div = document.getElementById('pdfpiechart');

                var chart = new google.visualization.PieChart(chart_div);
                // Wait for the chart to finish drawing before calling the getImageURI() method.
                google.visualization.events.addListener(chart, 'ready', function() {
                    chart_div.innerHTML = '<img src="' + chart.getImageURI() + '">';
                });

                chart.draw(data, printChartoptions);
            }

            var pbdd = resultString.pbdd;

            var resultPbDdBreed = resultString.resultPbDdBreed;
            var boBreed = resultString['boBreed'];
            var breedName = '';
            var index = pbdd; // initially set to true/false/PB/DD

            //          var outcome = "";
            // Text is special case for PB/BO Positive/Negative/Uncertain
            if (resultPbDdBreed.length > 0 && resultPbDdBreed[0]['type'] == 'Wisdom_PB') {
                breedName = resultPbDdBreed[0]['breed_1'];

                // additional PB/BO text
                if (boBreed.length > 0) {
                    angular.forEach(resultString.resultPbDd, function(value, key) {
                        if (value['evidence'] == 'final_outcome') {

                            index = value['outcome']; // index for pb outcome description
                            // console.log('inside pbddBO index'+index);
                        }
                    });
                }
            }


            var boMegaMutt = false;
            if (boBreed != null && boBreed.length != 0 && breedName.length != 0) {
                //			    index = outcome; // Positive/Negative/Uncertain
                $scope.disclaimer = fields.disclaimer; // add disclaimer only for PB/BO
                boMegaMutt = true;
            } else if (pbdd == 'false') {
                //			if (pbdd == 'false' && boBreed.length == 0 && breedName.length == 0) {
                var megaMuttFlag = resultString.resultDetail['megaMutt'];
                index = (megaMuttFlag === undefined || megaMuttFlag == '0') ? 'MB' : 'MM';
            }
            var description;
            var pbDescription = fields.pbDescription;

            var megaMutt = resultString.resultDetail['megaMutt'];

            $scope.breedType = index;
            if (megaMuttFlag !== undefined && megaMutt == 1) {
                // description =  (pbDescription[index]+'\n' + pbDescription['BodyMM']).replaceAll('[BREED NAME]', breedName);
                description = ((breedName.length > 0 && boBreed.length > 0) ? pbDescription[index] + pbDescription['BodyMM'] : fields.breedwiseDescription[index]).replaceAll('[BREED NAME]', breedName);
            } else {
                description = ((breedName.length > 0 && boBreed.length > 0) ? pbDescription[index] + pbDescription['Body'] : fields.breedwiseDescription[index]).replaceAll('[BREED NAME]', breedName);
            }
            $scope.descriptionArray = [];
            angular.forEach(description.split("\n"), function(value, key) {
                if (value != '') {
                    //		            $scope.descriptionArray.push(value.replaceAll('[DOG NAME]', sampleDetails.petDetails.petName).replaceAll('[REDIRECT]',"<a href='#/breeds/3OiTX2kmm4ow2yCSW0MiSm'>Breed</a>"));
                    $scope.descriptionArray.push(value.replaceAll('[DOG NAME]', sampleDetails.petDetails.petName));

                }
            });



            EntryService.getEntry(EntryIDService.getEntryID('The Science')).then(function(response) {
                var fields = response.fields;
                $scope.description = fields.description;
                $scope.scienceDescriptionArray = [];

                angular.forEach($scope.description.split("\n"), function(value, key) {
                    if (value != '') {
                        $scope.scienceDescriptionArray.push(value);
                    }
                });
            });
            $window.ga('send', 'pageview', {
                'page': $rootScope.pageTitle
            });
        }, function(error) {
            // promise rejected, could log the error with:
            // console.log('error', error);
        });
    }).name;


// WEBPACK FOOTER //
// ./client/apps/dnareport/controllers/percentage.controller.js